import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  HostListener,
  input,
  output,
  signal,
} from '@angular/core';
import { AddressLookupResp } from '@shared/interfaces/address-lookup';
import { MappedAddressLookup } from '@pages/poi-page/interfaces';

@Component({
  selector: 'app-address-search-result-box',
  templateUrl: './address-search-result-box.component.html',
  styleUrls: ['./address-search-result-box.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressSearchResultBoxComponent {
  addresses = input<AddressLookupResp[]>();
  addressSelected = output<AddressLookupResp>();
  searchClosed = output<void>();

  mappedAddresses = signal<MappedAddressLookup[] | undefined>(undefined);

  constructor() {
    effect(() => {
      const addresses = this.addresses();
      this.mappedAddresses.set(this.mapAddressTextStringToObj(addresses || []));
    });
  }

  @HostListener('document:click') onDocumentClick(): void {
    const searchDiv = document.getElementById('vt-address-lookup');

    if (searchDiv) {
      this.mappedAddresses.set([]);
    }
    this.searchClosed.emit();
  }

  onAddressSelected(address: AddressLookupResp): void {
    this.addressSelected.emit(address);
    this.searchClosed.emit();
  }

  private mapAddressTextStringToObj(
    addresses: AddressLookupResp[]
  ): MappedAddressLookup[] {
    return addresses.map(address => {
      const addressObjectDefinedValues: (string | number | object)[] =
        Object.values(address).filter(v => v);
      const definedValuesNumber = addressObjectDefinedValues.length;

      // map one additional property to address object (text) that holds defined object values
      // separated by commas for displaying text in the search box
      let text = '';
      addressObjectDefinedValues.forEach((val, index) => {
        if (!(typeof val === 'object')) {
          text = text + val + (index < definedValuesNumber - 1 ? ', ' : '');
        }
      });

      return { ...address, text };
    });
  }
}
